"use client";

import { Anchor, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CustomLink() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const contactDetails = [{
    icon: MapPin,
    text: "Ocean Springs, Mississippi"
  }, {
    icon: Phone,
    text: "(228) 555-1212"
  }, {
    icon: Mail,
    text: "info@themissyvonne.com"
  }];
  return <section id="custom-link" className="w-full bg-background py-24 md:py-40 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex justify-between px-8 max-w-[1440px] mx-auto opacity-10">
        <div className="w-[1px] h-full bg-foreground"></div>
        <div className="w-[1px] h-full bg-foreground"></div>
        <div className="w-[1px] h-full bg-foreground"></div>
        <div className="w-[1px] h-full bg-foreground"></div>
      </div>

      <div ref={ref} className={`max-w-[1440px] mx-auto px-8 relative z-10 transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 items-center">
          {}
          <div className="relative group">
            {}
            <div className="absolute -left-8 top-1/2 -translate-y-1/2 -rotate-90 origin-center hidden lg:block z-20">
              <span className="font-mono text-xs tracking-widest text-muted-foreground uppercase whitespace-nowrap">
                30° 24' 42" N // 88° 49' 42" W
              </span>
            </div>

            <div className="relative rounded-md overflow-hidden border border-border shadow-xl transition-all duration-300 group-hover:border-primary">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_dock.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_dock.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_dock.png-wvc-sizes" alt="The Miss Yvonne docked in Ocean Springs" className="w-full h-[400px] md:h-[600px] object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-foreground/5 mix-blend-overlay pointer-events-none"></div>
            </div>
          </div>

          {}
          <div className="flex flex-col items-start">
            <span className="font-mono text-sm uppercase tracking-widest text-muted-foreground mb-6 flex items-center gap-3">
              <Anchor className="w-4 h-4 text-primary" />
              The Logbook // 01
            </span>

            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-8 leading-[1.1]">
              Direct From <br className="hidden md:block" /> The Dock
            </h2>

            <p className="font-sans text-lg md:text-xl text-foreground/80 mb-12 leading-relaxed max-w-lg">
              Located in the heart of Ocean Springs, Mississippi. Reach out to us
              for premium wild-caught seafood, commercial inquiries, or to learn
              more about our heritage.
            </p>

            <div className="flex flex-col gap-6 mb-12 w-full max-w-md">
              {contactDetails.map((detail, i) => <div key={i} data-index={i} className="flex items-center gap-6 pb-6 border-b border-border last:border-0 last:pb-0">
                  <div className="w-12 h-12 rounded-lg border border-border flex items-center justify-center shrink-0 text-primary bg-background shadow-sm">
                    <detail.icon className="w-5 h-5" />
                  </div>
                  <span className="font-sans text-lg text-foreground">
                    {detail.text}
                  </span>
                </div>)}
            </div>

            <Button asChild variant="secondary" size="lg" className="font-mono uppercase tracking-widest rounded-md px-10 py-7 text-secondary-foreground hover:bg-foreground hover:text-background transition-colors duration-150 shadow-md">
              <Link to="/ContactPage">Contact The Captain</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}